// extracted by mini-css-extract-plugin
export var firstGlow = "styles-module--first-glow--067b9";
export var mainContent = "styles-module--main-content--c46aa";
export var subtitle = "styles-module--subtitle--baf04";
export var suptitle = "styles-module--suptitle--414a2";
export var title = "styles-module--title--78de0";